import axios from 'axios';

// Get all inventory items
export const getInventory = async (filters = {}) => {
  try {
    let queryString = '';
    if (filters.location_id) queryString += `location_id=${filters.location_id}&`;
    if (filters.part_id) queryString += `part_id=${filters.part_id}&`;
    if (filters.search) queryString += `search=${encodeURIComponent(filters.search)}&`;
    if (filters.low_stock) queryString += `low_stock=${filters.low_stock}&`;
    if (filters.page) queryString += `page=${filters.page}&`;
    if (filters.limit) queryString += `limit=${filters.limit}&`;

    console.log('Inventory API request URL:', `/api/inventory?${queryString}`);
    console.log('Inventory API request filters:', filters);

    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/inventory?${queryString}`, {
      headers: {
        'x-auth-token': token
      }
    });

    console.log('Inventory API raw response:', res);
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching inventory' };
  }
};

// Get inventory transactions
export const getInventoryTransactions = async (filters = {}) => {
  try {
    let queryString = '';
    if (filters.part_id) queryString += `part_id=${filters.part_id}&`;
    if (filters.location_id) queryString += `location_id=${filters.location_id}&`;
    if (filters.user_id) queryString += `user_id=${filters.user_id}&`;
    if (filters.start_date) queryString += `start_date=${filters.start_date}&`;
    if (filters.end_date) queryString += `end_date=${filters.end_date}&`;
    if (filters.limit) queryString += `limit=${filters.limit}&`;
    if (filters.page) queryString += `page=${filters.page}&`;

    console.log('Transactions API request URL:', `/api/inventory/transactions?${queryString}`);

    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/inventory/transactions?${queryString}`, {
      headers: {
        'x-auth-token': token
      }
    });

    console.log('Transactions API response:', res.data);

    // Handle both new and old response formats
    return res.data.items || res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching transactions' };
  }
};

// Adjust inventory
export const adjustInventory = async (adjustmentData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post('/api/inventory/adjust', adjustmentData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error adjusting inventory' };
  }
};

// Get item by barcode
export const getItemByBarcode = async (barcode) => {
  try {
    const token = localStorage.getItem('token');
    // URL encode the barcode to handle special characters like slashes
    const encodedBarcode = encodeURIComponent(barcode);
    const res = await axios.get(`/api/inventory/barcode/${encodedBarcode}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching item by barcode' };
  }
};

// Associate UPC code with a supplier part
export const associateUpc = async (upcData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post('/api/inventory/associate-upc', upcData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error associating UPC code' };
  }
};

// Move inventory between locations
export const moveInventory = async (moveData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post('/api/inventory/move', moveData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error moving inventory' };
  }
};